"use strict"

import PushNotification from "react-native-push-notification"

export default PushNotification
